import React from 'react';
import { Table } from 'react-bootstrap';
import THead from "./components/THead";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';
import { roundTo3Decimal, sortArray } from "../../../../Utils";
import { calculateECost } from "../../prepareReport";

const PeriodTable = ({ reportObj, subids, device, countries, sortParam, sortOrder, onSortChange }) => {
    const { report } = reportObj;
    const rowsData = getRowsData(report, subids, device, countries);
    const total = calcTotal(rowsData);

    if(sortParam) sortArray(rowsData, sortParam, sortOrder);
    const rows = rowsData.map(row => <Row {...row} key={`${row.affid}:${row.subid}:${row.device}`}/>);

    return (
        <Table bordered responsive>
            <THead onSortChange={onSortChange}/>
            <tbody>
                <TotalRow {...total} />
                {rows}
            </tbody>
        </Table>
    )
};

function calcTotal(data) {
    const totals = data.reduce((obj, { spends, conversions }) => {
        if(spends) obj.spends += spends;
        if(conversions) obj.conversions += conversions;

        return obj;
    }, { spends: 0, conversions: 0 });

    totals.eCost = calculateECost(totals.spends, totals.conversions);

    return totals;
}

function getRowsData(report, subids, selectedDevice, countries) {
    return report.reduce((arr, { affid, subid, device, ...row }) => {
        let isMatchFilters = true;

        if(subids.length && subids.indexOf(subid) === -1) isMatchFilters = false;
        else if(selectedDevice && selectedDevice !== device) isMatchFilters = false;

        if(isMatchFilters) {
            if(countries.length) countries.forEach(country => arr.push({ affid, subid, device, country, ...getValues(row) }));
            else arr.push({ affid, subid, device, ...getValues(row) });
        }

        return arr;
    }, []);
}

function getValues(data, country) {
    let spends = 0, conversions = 0, eCost = 0;
    if(data) {
        if(data.spends) {
            spends = country ? data.spends[country] : data.totalSpends;
            if(spends) spends = roundTo3Decimal(spends);
        }
        if(data.conversions) conversions = country ? data.conversions[country] : data.totalConversions;
        if(data.eCost) {
            eCost = country ? data.eCost[country] : data.avgECost;
            if(eCost) eCost = roundTo3Decimal(eCost);
        }
    }

    return { spends, conversions, eCost };
}

export default PeriodTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/PeriodTable/index.js